<template>
    <div>
        <div v-for="level in current_level" class="decision-level">
            <div class="row">
                <div v-for="node in node_herarchy[level-1]" class="col-auto">
                    <div class="domain-list">
                        <div class="domain-list" v-if="!node.interlinked_body">
                            <a href="#" class="domain-list-link" :class="getNodeClass(node.id)" @click.prevent="showNode(node, level)">
                                <span :class="'color-' + product + ' fa ' + (node.type === 'article' ? 'fa-copy' : 'fa-plus')"></span> {{node.decision_node_translation_set[0].title}}
                            </a>
                        </div>
                        <div class="domain-list" v-else-if="node">
                            <div class="domain-list-link result" v-html="node.interlinked_body">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
        </div>
        <template v-if="current_nodes[0].interlinked_body">
            <strong>Resultaat:</strong><br>
        </template>
        <div class="row decision-level-last">
            <div v-for="(item) in current_nodes" class="col-auto">
                <div class="domain-list" v-if="!item.interlinked_body">
                    <a href="#" class="domain-list-link" @click.prevent="showNode(item)">
                        <span class="fa" :class="item.type === 'article' ? 'fa-copy' : 'fa-plus'"></span> {{item.decision_node_translation_set[0].title}}
                    </a>
                </div>
                <div class="domain-list" v-else-if="item">
                    <div :class="'domain-list-link result ' + product" v-html="item.interlinked_body">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

        props: ['nodes', 'domain_slug', 'subdomain_slug', 'article_slug', 'product'],
        data() {
            return {
                current_nodes: this.nodes,
                node_herarchy: {},
                selected_nodes: [],
                current_level: 0,
            }
        },
        methods: {
            showNode(item, level=-1) {
                if (item.type==='article') {
                    window.location.href = route('Article.GetArticleDetail',
                        {
                            'locales': locale,
                            'domain_slug': item.article_details.subdomain.domain.domain_language_slug,
                            'subdomain_slug': item.article_details.subdomain.subdomain_language_slug,
                            'article_slug': item.article_details.slug,
                            'product': this.product
                        });
                } else {

                    this.node_herarchy[this.current_level] = this.current_nodes;
                    this.current_nodes = item.children;
                    if (level === -1) {
                        this.current_level += 1;
                        this.selected_nodes.push(item.id);
                    } else {
                        this.current_level = level;
                        this.selected_nodes = this.selected_nodes.slice(0, level);
                        this.selected_nodes[this.selected_nodes.length-1] = item.id;
                    }

                    let scrollToElement = $('.decision-level-last');
                    $('html, body').animate({
                        scrollTop: scrollToElement.offset().top
                    }, 300);
                }
            },

            getNodeClass(id) {
                if (this.selected_nodes.indexOf(id) !== -1) {
                    return "active color-" + this.product;
                }
            }
        }
    }
</script>
<style>

</style>


// WEBPACK FOOTER //
// resources/js/components/decision-tree/DecisionNode.vue